import { TextInput, Button, Select, Tooltip } from "flowbite-react";
import {
  FaSortAlphaDown,
  FaSortAmountDown,
  FaSortAmountUp,
} from "react-icons/fa";

const FiltroProdutos = ({ onSearch, onSort, status, onStatusChange }) => {
  return (
    <div className="flex flex-col md:flex-row justify-between items-center mb-4 gap-4">
      <TextInput
        placeholder="Pesquisar por referência, descrição ou marca..."
        onChange={onSearch}
        className="w-full md:flex-1"
      />
      <div className="flex w-full flex-wrap items-center gap-2 md:w-auto">
        <Select
          value={status}
          onChange={(event) => onStatusChange(event.target.value)}
          className="min-w-36"
        >
          <option value="ativos">Ativos</option>
          <option value="inativos">Inativos</option>
          <option value="todos">Todos</option>
        </Select>
        <Tooltip content="Mais novos">
          <Button
            onClick={() => onSort("newest")}
            gradientDuoTone="purpleToPink"
            outline
          >
            <FaSortAmountDown />
          </Button>
        </Tooltip>
        <Tooltip content="Mais antigos">
          <Button
            onClick={() => onSort("oldest")}
            gradientDuoTone="purpleToPink"
            outline
          >
            <FaSortAmountUp />
          </Button>
        </Tooltip>
        <Tooltip content="A-Z">
          <Button
            onClick={() => onSort("alphabetical")}
            gradientDuoTone="purpleToPink"
            outline
          >
            <FaSortAlphaDown />
          </Button>
        </Tooltip>
      </div>
    </div>
  );
};

export default FiltroProdutos;
